import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { booleanQuerySchema, currencyInput, paginatedResponseSchema } from '@/_schemas/generic';
import { statusQuerySchema } from '@/_schemas/status-input';

import { partnerQueryLinkerSchema } from './partner-query-linker-schema';

import { invoiceQueryLinkerSchema } from '../../../../invoices/shared/schemas/invoices/invoice-query-linker-schema';

export const partnerQuerySchema = z.object({
  ...partnerQueryLinkerSchema.shape,
  created_at: z.string(),
  updated_at: z.string(),
  handle_invoicing: booleanQuerySchema(),
  invoices: z.array(invoiceQueryLinkerSchema),

  code: z.string().nullable(),
  website: z.string().nullable(),
  email: z.string().nullable(),
  status: statusQuerySchema,

  logo: z.array(fileQuerySchema).nullish(),
  logo_light: z.array(fileQuerySchema).nullish(),

  // Termination & Notice Tracking
  termination_notice_date: z.string().nullable(),
  required_notice_days: z.number().nullable(),
  calculated_termination_date: z.string().nullable(),
  override_termination_date: z.string().nullable(),
  termination_extension_days: z.number().nullable(),
  final_termination_date: z.string().nullable(),

  // Tail Commission Settings
  tail_enabled: z.boolean(),
  tail_percentage: z.number().nullable(),
  tail_duration_months: z.number().nullable(),
  tail_flat_monthly_payout: currencyInput.querySchema(),
  tail_start_month: z.string().nullable(),

  // Transition period settings
  transition_tail_enabled: z.boolean(),
  transition_tail_percentage: z.number().nullable(),
  transition_tail_duration_months: z.number().nullable(),
  transition_tail_start_month: z.string().nullable(),
});

export type PartnerQuerySchema = z.infer<typeof partnerQuerySchema>;

export const partnerQueryAllSchema = paginatedResponseSchema(partnerQuerySchema);

export type PartnerQueryAllSchema = z.infer<typeof partnerQueryAllSchema>;
